<template>
  <div class="bg-white table-padding rounded shadow relative">
    <div slot="header" class="flex justify-between items-center flex-wrap">
      <span class="title">ユーザ一覧</span>
      <div class="search-user">
        <el-input
          placeholder="検索"
          v-model="keySearch"
          @input="keyUpSearch()"
          class="mr-6 w-1/2 custom-input"
        >
          <template #append>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              @click="getListUser"
              class="cursor-pointer"
            >
              <path
                d="M15.102 14.1188L10.4645 9.48129C11.1841 8.55093 11.5734 7.41343 11.5734 6.21701C11.5734 4.78486 11.0145 3.44201 10.0038 2.42951C8.99306 1.41701 7.64663 0.859863 6.21627 0.859863C4.78592 0.859863 3.43949 1.41879 2.42877 2.42951C1.41627 3.44022 0.859131 4.78486 0.859131 6.21701C0.859131 7.64736 1.41806 8.99379 2.42877 10.0045C3.43949 11.017 4.78413 11.5741 6.21627 11.5741C7.4127 11.5741 8.54842 11.1849 9.47877 10.467L14.1163 15.1027C14.1299 15.1163 14.146 15.1271 14.1638 15.1345C14.1816 15.1418 14.2006 15.1456 14.2198 15.1456C14.2391 15.1456 14.2581 15.1418 14.2759 15.1345C14.2937 15.1271 14.3098 15.1163 14.3234 15.1027L15.102 14.3259C15.1156 14.3123 15.1264 14.2962 15.1338 14.2784C15.1411 14.2606 15.1449 14.2416 15.1449 14.2224C15.1449 14.2031 15.1411 14.1841 15.1338 14.1663C15.1264 14.1485 15.1156 14.1324 15.102 14.1188ZM9.04484 9.04558C8.2877 9.80093 7.28413 10.217 6.21627 10.217C5.14842 10.217 4.14485 9.80093 3.3877 9.04558C2.63235 8.28843 2.21627 7.28486 2.21627 6.21701C2.21627 5.14915 2.63235 4.14379 3.3877 3.38843C4.14485 2.63308 5.14842 2.21701 6.21627 2.21701C7.28413 2.21701 8.28949 2.63129 9.04484 3.38843C9.8002 4.14558 10.2163 5.14915 10.2163 6.21701C10.2163 7.28486 9.8002 8.29022 9.04484 9.04558Z"
                fill="black"
                fill-opacity="0.45"
              />
            </svg>
          </template>
        </el-input>

        <el-button
          @click="isOpenCreateModal = true"
          type="text"
          title="テンプレートを追加する"
          class="custom-btn-add"
          :disabled="amountLimit <= paginate.totalItem"
        >
          ユーザー追加
        </el-button>
      </div>
    </div>
    <el-table :data="dataListUser" class="w-full data-user mt-4 height-list mb-14">
      <template v-slot:empty>
        <span>データなし</span>
      </template>
      <el-table-column label="ユーザー名" prop="full_name" min-width="250"></el-table-column>
      <el-table-column label="ユーザーのメールアドレス" prop="email" min-width="250"></el-table-column>
      <el-table-column label="作成日" prop="full_name" min-width="100" >
        <template slot-scope="scope">
          <p>{{scope.row.updated_at | formatDate}}</p>
        </template>
      </el-table-column>
      <el-table-column label="" min-width="150" align="right">
        <template slot-scope="scope">
          <el-button
              type="primary"
              @click="editUser(scope.row)"
              icon="el-icon-edit"
          >
          </el-button>
          <el-button @click="showDeleteUser(scope.row)" icon="el-icon-delete">
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- DATA -->
<!--    <div class="w-full data-user mt-4 height-list mb-14">-->
<!--      <table class="w-full">-->
<!--        <thead>-->
<!--          <tr>-->
<!--            <th>ユーザ名</th>-->
<!--            <th>ユーザのメールアドレス</th>-->
<!--            <th>作成日</th>-->
<!--            <th></th>-->
<!--          </tr>-->
<!--        </thead>-->
<!--        <tbody v-if="dataListUser.length > 0">-->
<!--          <tr v-for="user in dataListUser" :key="user.id" class="border-b">-->
<!--            <td class="w-2/6 text-left">{{ user.full_name }}</td>-->
<!--            <td class="w-2/6 text-left">{{ user.email }}</td>-->
<!--            <td class="w-1/6 text-left">{{ formatDate(user.updated_at) }}</td>-->
<!--            <td class="w-1/6 text-center">-->
<!--              <div>-->
<!--                <el-button-->
<!--                  type="primary"-->
<!--                  @click="editUser(user)"-->
<!--                  icon="el-icon-edit"-->
<!--                >-->
<!--                </el-button>-->
<!--                <el-button @click="showDeleteUser(user)" icon="el-icon-delete">-->
<!--                </el-button>-->
<!--              </div>-->
<!--            </td>-->
<!--          </tr>-->
<!--        </tbody>-->
<!--        <tbody v-else>-->
<!--          <tr>-->
<!--            <td colspan="4" class="text-center">データなし</td>-->
<!--          </tr>-->
<!--        </tbody>-->
<!--      </table>-->
<!--    </div>-->

    <!-- PAGINATE -->
    <el-pagination
      class="text-right mt-4 absolute right-0 bottom-0 w-full bg-white py-4"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="paginate.currentPage"
      :page-sizes="configPaginate.page_sizes"
      :page-size="configPaginate.page_size"
      layout="prev, pager, next, sizes"
      :total="paginate.totalItem"
    >
    </el-pagination>

    <!-- MODAL ADD USER -->
    <CreateUser
      :isOpenCreateModal.sync="isOpenCreateModal"
      :org-id="org_id"
      @close="isOpenCreateModal = false"
      @onUserCreated="onUserCreated"
    />

    <!-- MODAL UPDATE USER -->
    <EditUser
      :isOpenEditModal.sync="isOpenEditModal"
      :org-id="org_id"
      :propUserDetail="userDetail"
      @close="isOpenEditModal = false"
      @onUserUpdated="onUserUpdated"
    />

    <!-- DIALOG DELETE USER -->

    <el-dialog title="" :visible.sync="isOpenDeleteModal" width="30%">
      <span>このユーザーを削除しますか。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isOpenDeleteModal = false">いいえ</el-button>
        <el-button type="danger" @click="submitDelete">
          はい、削除する
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import CreateUser from "@/components/admin/user/create";
import EditUser from "@/components/admin/user/edit";
import formatDate from "@/plugins/formatDate.js";
import { configPaginate } from "@/config/paginate";
import {ROLE_ADMIN} from "@/constants/organization";

export default {
  props: ["id"],

  components: {
    CreateUser,
    EditUser,
  },
  filters: {
    formatDate: formatDate
  },

  data: function() {
    return {
      configPaginate,
      paginate: {
        currentPage: 1,
        totalPage: 1,
        totalItem: 1,
      },
      amountLimit: 0,
      keySearch: null,
      typingTimer: null,
      dataListUser: [],
      userDetail: {},
      totalPage: 1,
      isOpenCreateModal: false,
      isOpenEditModal: false,
      isOpenDeleteModal: false,
      userId: null,
      org_id: null
    };
  },

  computed: {
    ...mapState({
      users: (state) => state.admin_user.users,
      organizations: (state) => state.admin_organizations.organizations,
      authUser: state => state.auth.authUser
    }),
  },

  methods: {
    ...mapActions("admin_user", ["getDetailUser", "getUsers", "deleteUser"]),
    ...mapActions("admin_organizations", ["getDetail"]),
    handleSizeChange(val) {
      this.configPaginate.page_size = val;
      this.getListUser();
    },

    async getAmountLimit() {
      const data = {
        id: this.org_id
      }
      let resDetail = await this.getDetail(data);
      this.amountLimit = resDetail.data.amount_limit;
    },

    keyUpSearch() {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(() => {
        this.getListUser();
      }, 500);
    },

    async getListUser() {
      this.org_id = this.$route.params.id ? this.$route.params.id : this.authUser.org_id
      const data = {
        page: this.paginate.currentPage,
        org_id: this.org_id,
        page_size: this.configPaginate.page_size,
        key_search: this.keySearch,
      };
      const result = await this.getUsers(data);
      if (result.success) {
        const rs = result.data;
        this.dataListUser = rs.results;
        this.paginate.currentPage = rs.current_page;
        this.configPaginate.page_size = rs.page_size;
        this.paginate.totalPage = rs.num_pages;
        this.paginate.totalItem = rs.count;
      }
    },

    async handleCurrentChange(val) {
      this.paginate.currentPage = val;
      this.getListUser();
    },
    showDeleteUser(user) {
      this.userId = user.id;
      this.isOpenDeleteModal = true;
    },

    async editUser(user) {
      this.userDetail = user;
      this.userId = user.id;
      const res = await this.getDetailUser({ id: this.userId });
      if (res.success) {
        this.isOpenEditModal = true;
      }
    },

    onUserCreated() {
      this.isOpenCreateModal = false;
      this.getUsers(this.paginate);
      this.getListUser();
    },

    onUserUpdated() {
      this.isOpenEditModal = false;
      this.getUsers(this.paginate);
      this.getListUser();
    },

    async submitDelete() {
      let res = await this.deleteUser({
        id: this.userId,
      });
      this.isOpenDeleteModal = false;
      if (!res.success) {
        this.errorMessages = res.data.message;
        this.$message.error({
          message: res.data.message,
        });
        return false;
      }
      await this.getListUser();
      this.errorMessages = null;
    },


    formatDate,
  },

  async created() {
    if (this.authUser.role === ROLE_ADMIN && this.authUser.is_superuser) {
      if (!this.$route.params.id) {
        return this.$router.push('/404')
      }
      const res = await this.getDetail({id: this.$route.params.id})
      if (!res.success) {
        return this.$router.push('/404')
      }
    }
    this.org_id = this.$route.params.id ? this.$route.params.id : this.authUser.org_id
    this.getListUser();
    await this.getAmountLimit()
  },
};
</script>

<style scoped>
.search-user {
  display: flex;
  justify-content: flex-end;
}
.title {
  margin-bottom: unset;
}
/deep/.el-table--enable-row-transition > .el-table__body > .el-table__row > td {
  transition: unset;
}
.el-table--border::after, .el-table--group::after, .el-table::before {
  content: '';
  position: absolute;
   background-color: unset;
  z-index: 1;
}

.height-list {
  height: calc(100vh - 320px);
  overflow-y: scroll;
}
.height-list::-webkit-scrollbar {
  display: none;
}
.custom-btn-add {
  background: #fdb92c;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  color: #0f172a;
  padding: 5px 16px;
  font-weight: 400;
}
.data-user table th {
  padding: 17px 10px;
  font-weight: 400;
  background: #fdf4e0;
  text-align: left;
  color: black;
}
/deep/ table > thead{
  color: rgba(0, 0, 0, 0.65);
}
.data-user table td {
  padding: 10px;
  color: black;
}

 @media screen and (max-width: 1366px){
   .table-padding {
     padding: 1.6rem;
   }
   /deep/ .el-dialog {
     min-width: 500px;
   }
 }
@media screen and (max-width: 768px){
  /deep/ .el-dialog {
    min-width: 340px;
  }
  .table-padding {
    padding: 1rem;
  }
  .search-user {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .title {
    margin-bottom: 10px;
  }
 }

@media screen and (max-width: 300px){
  /deep/ .el-dialog {
    min-width: 280px;
  }
  .table-padding {
    padding: 1rem;
  }
  .title {
    margin-bottom: 10px;
  }
  .custom-btn-add {
    width: 100%;
  }
  .custom-input {
    width: 100%;
    margin-bottom: 10px;
  }
}

</style>
